/*
 * @Date: 2022-07-11 14:27:16
 * @LastEditTime: 2023-05-11 11:09:27
 */

import { message } from 'ant-design-vue';
import dayjs from 'dayjs';
import { cloneDeep } from 'lodash';
import * as api from '@/api/index';

/**
 * @description: 内容拼接
 * @param {*} data
 * @return {*}
 */
export function parameterChange(data) {
  let res = ``;
  for (const key in data) {
    let dataKey = '';
    if (data[key] || data[key] === 0) dataKey = data[key];
    res = `${res}&${key}=${dataKey}`;
  }
  return res.substr(1);
}

// 复制文本
export function copyText(text) {
  return new Promise((resolve) => {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed'; // 使其在视口之外
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    resolve();
  });
}

// 获取file名称
export function getFileName(info) {
  if (!info) return;
  return info.split('/').pop();
}

export function getFormData(arr, callback) {
  let temp = {};
  for (let item of arr) {
    if (item.doNotGet) continue;
    if (['image'].includes(item.type)) {
      const imgArr = item.value.map((imgItem) => imgItem.url);
      temp[item.key] = imgArr.join(',') || '';
    } else if (['checkbox'].includes(item.type)) {
      temp[item.key] = item.value.join(',') || '';
    } else if (['addInput'].includes(item.type)) {
      const options = {};
      item.value.forEach((option) => {
        let imgs = [];
        option.image.value.forEach((img) => {
          imgs.push(img.url);
        });
        options[option.index] = { text: option.text, image: imgs.join(',') };
      });
      temp[item.key] = JSON.stringify(options);
    } else if (['cascader'].includes(item.type)) {
      temp[item.key] = item.value ? JSON.stringify(item.value) : null;
    } else if (['fieldDesigner'].includes(item.type)) {
      // 字段设计器：先剔除脏数据（key/label 任一为空的行视为未填写）
      const cleaned = (item.value || []).filter(
        (f) => f && String(f.key || '').trim() && String(f.label || '').trim(),
      );
      temp[item.key] = cleaned.length ? JSON.stringify(cleaned) : null;
    } else {
      temp[item.key] = !['', undefined, null].includes(item.value) ? item.value : '';
    }
  }
  if (callback) {
    temp = callback(temp);
  }
  return temp;
}

export function handleReview(item) {
  return {
    uid: Date.now() + Math.random(),
    name: getFileName(item),
    status: 'done',
    url: item,
  };
}

export function getFormValue(obj, item) {
  let val, valCn;
  if (obj?.hasOwnProperty(item.key)) {
    if (['image'].includes(item.type)) {
      val = [];
      let arr = obj[item.key]?.split(',');
      arr.forEach((item) => {
        if (item) {
          val.push(handleReview(item));
        }
      });
    } else if (['checkbox'].includes(item.type)) {
      val = obj[item.key]?.split(',');
    } else if (['radio', 'select'].includes(item.type)) {
      val = obj[item.key];
    } else if (['addInput'].includes(item.type)) {
      const temp = [];
      const data = JSON.parse(obj[item.key]);
      Object.keys(data).forEach((key) => {
        let arr = data[key].image?.split(',');
        let imgVal = [];
        arr.forEach((item) => {
          if (item) {
            imgVal.push(handleReview(item));
          }
        });

        const tempObj = {
          index: key,
          text: data[key].text,
          image: {
            maxCount: 1,
            path: 'exam/img/quesBank',
            value: imgVal,
          },
        };
        temp.push(tempObj);
      });
      val = temp;
    } else if (['cascader'].includes(item.type)) {
      val = JSON.parse(obj[item.key]);
    } else if (['fieldDesigner'].includes(item.type)) {
      // 字段设计器：从 JSON 字符串反序列化为数组；
      // 老考核没配置 infoFields 时返回 defaultValue（保证至少展示系统字段）
      try {
        const raw = obj[item.key];
        if (raw) {
          val = typeof raw === 'string' ? JSON.parse(raw) : raw;
          if (!Array.isArray(val) || val.length === 0) {
            val = item.defaultValue ? cloneDeep(item.defaultValue) : [];
          }
        } else {
          val = item.defaultValue ? cloneDeep(item.defaultValue) : [];
        }
      } catch (e) {
        val = item.defaultValue ? cloneDeep(item.defaultValue) : [];
      }
    } else if (['switch'].includes(item.type)) {
      val = obj[item.key] == 'true';
    } else {
      val = obj[item.key] + '';
    }

    if (['date', 'dateTime'].includes(item.type)) {
      valCn = new dayjs(obj[item.key]);
    }
  } else {
    if (['image', 'checkbox'].includes(item.type)) {
      val = [];
    } else if (['fieldDesigner'].includes(item.type)) {
      // 后端没返回该字段：退回 defaultValue（保证至少展示系统字段）
      val = item.defaultValue ? cloneDeep(item.defaultValue) : [];
    } else {
      val = undefined;
    }
  }
  return { val, valCn };
}

export function judgeSubmit(arr) {
  let flag = true;
  for (let item of arr) {
    if (
      item.hasOwnProperty('require') &&
      item.require &&
      ((!['checkbox'].includes(item.type) && ['', null, undefined].includes(item.value)) ||
        (['checkbox'].includes(item.type) && !item.value.length))
    ) {
      flag = false;
      message.error(
        `请${['select', 'checkbox', 'checkbox', 'image', 'radio'].includes(item.type) ? '选择' : '填写'}${item.label}！`,
      );
      break;
    }

    // 字段设计器：每行 key/label 都必须填写，且 key 不能重复
    if (item.type === 'fieldDesigner' && Array.isArray(item.value) && item.value.length) {
      const keys = new Set();
      for (let i = 0; i < item.value.length; i++) {
        const f = item.value[i] || {};
        const label = String(f.label || '').trim();
        const key = String(f.key || '').trim();
        if (!label || !key) {
          message.error(`【${item.label}】第 ${i + 1} 行请完整填写"字段名"和"字段Key"`);
          return false;
        }
        if (!/^[a-zA-Z][a-zA-Z0-9_]*$/.test(key)) {
          message.error(`【${item.label}】第 ${i + 1} 行字段Key只允许英文/数字/下划线，且必须以字母开头`);
          return false;
        }
        if (keys.has(key)) {
          message.error(`【${item.label}】字段Key "${key}" 重复`);
          return false;
        }
        keys.add(key);
        // type=select 必须至少有一个选项
        if (f.type === 'select' && (!Array.isArray(f.options) || f.options.length === 0)) {
          message.error(`【${item.label}】"${label}" 是下拉选择，请至少配置一个选项`);
          return false;
        }
      }
    }
  }
  return flag;
}

export const findItem = (arr, field, fieldName) => {
  return arr.find((item) => item[field] == fieldName);
};

export const isValidJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * 解析 teamClass 字段并返回对应的中文名称
 * @param {string|null} teamClass - 原始 teamClass 字段值（可能为 null, '[[7]]', '[[7],[6,1]]' 等）
 * @returns {Promise<string>} - 返回团队/班级的中文名称组合，如 "团队A(班级1), 团队B(班级2)"
 */
// 创建缓存对象
const cache = {
  teamMap: null,
  classMaps: new Map(), // 存储每个团队的班级映射
  lastFetchTime: 0,
  CACHE_DURATION: 5 * 60 * 1000, // 5分钟缓存
};

export const resolveTeamClassName = async (teamClass) => {
  if (!teamClass || teamClass === 'null') return '';

  let classData;
  try {
    classData = JSON.parse(teamClass);
  } catch (e) {
    console.error('解析 teamClass 失败:', e);
    return '';
  }

  // 1. 获取团队数据（使用缓存）
  const now = Date.now();
  if (!cache.teamMap || now - cache.lastFetchTime > cache.CACHE_DURATION) {
    try {
      const teamRes = await api.default.teamList();
      cache.teamMap = new Map(teamRes.data.map((t) => [t.value, t.label]));
      cache.lastFetchTime = now;
    } catch (error) {
      console.error('获取团队列表失败:', error);
      // 使用旧缓存或创建空映射
      cache.teamMap = cache.teamMap || new Map();
    }
  }

  // 2. 获取所有需要查询的团队ID（去重）
  const teamIds = [...new Set(classData.map((group) => group[0]))];

  // 3. 批量获取班级数据（只请求未缓存的团队）
  const uncachedTeamIds = teamIds.filter((id) => !cache.classMaps.has(id));

  if (uncachedTeamIds.length > 0) {
    const classRequests = uncachedTeamIds.map(async (teamId) => {
      try {
        const res = await api.default.classList({ teamId });
        return {
          teamId,
          classMap: new Map(res.data.map((c) => [c.value, c.label])),
        };
      } catch (error) {
        console.error(`获取团队[${teamId}]班级失败:`, error);
        return { teamId, classMap: new Map() };
      }
    });

    const classResults = await Promise.all(classRequests);
    classResults.forEach(({ teamId, classMap }) => {
      cache.classMaps.set(teamId, classMap);
    });
  }

  // 4. 构建结果
  const results = [];

  for (const group of classData) {
    if (!group.length) continue;

    const [teamId, ...classIds] = group;
    const teamName = cache.teamMap.get(teamId) || `未知团队(${teamId})`;

    if (classIds.length === 0) {
      results.push(teamName);
      continue;
    }

    // 获取班级名称（使用缓存）
    const classMap = cache.classMaps.get(teamId) || new Map();
    const classNames = classIds.map((id) => classMap.get(id) || `未知班级(${id})`);

    results.push(`${teamName}(${classNames.join(',')})`);
  }

  return results.join(', ');
};

// 可选：添加清除缓存的方法
export const clearTeamClassCache = () => {
  cache.teamMap = null;
  cache.classMaps.clear();
  cache.lastFetchTime = 0;
};
